export default "/images/gjensidige.avif?a9ef48912e6c6f2f9ecde1da69c6b8ed";